import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import noop from "lodash/noop";

import { matchNode } from "../../utils/dom";

require("./DropDown.scss");

export default class DropDown extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
    this.onClickHandler = this.onClickHandler.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isOpen && this.state.isOpen) {
      document.addEventListener("click", this.onClickHandler);
    }

    if (prevState.isOpen && !this.state.isOpen) {
      document.removeEventListener("click", this.onClickHandler);
    }

    if (this.state.isOpen && this.props.disabled && !prevProps.disabled) {
      this.setState({ isOpen: false });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.onClickHandler);
  }

  onClickHandler(e) {
    e.preventDefault();
    e.stopPropagation();

    const isInside = matchNode(e.target, this.refs.drop);

    if (!isInside || e.target.tagName === "A") {
      this.setState({ isOpen: false });

      return false;
    }
  }

  render() {
    const { disabled } = this.props;
    const { isOpen } = this.state;

    const containerClasses = classNames("dropdown-container", { "dropdown-disabled": disabled });

    const listClasses = classNames({
      show: isOpen && !disabled,
      hidden: disabled || !isOpen,
    });

    const clickTitle = disabled ? "Disabled while loading entries" : "Set sort direction";

    const openDropdown = () => this.setState({ isOpen: true })

    return (
      <div className={containerClasses}>
        <p>
          <small className="header">
            {this.props.preLabel}
            <a title={clickTitle} onClick={disabled ? noop : openDropdown}>
              {this.props.label}
            </a>
          </small>
        </p>
        <ul ref="drop" className={listClasses}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

DropDown.displayName = "History.DropDown";

DropDown.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool.isRequired,
  preLabel: PropTypes.node,
  label: PropTypes.node,
};

DropDown.defaultProps = {
  disabled: false,
};



// WEBPACK FOOTER //
// ./app/components/History/DropDown.jsx